var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1789 8.92422C15.1789 13.0806 11.9831 16.4539 8.0455 16.4539C4.10787 16.4539 1.70392 12.2674 1.70392 12.2674M1.70392 12.2674H4.92821M1.70392 12.2674V16.0322M0.912109 8.92422C0.912109 4.76783 4.07933 1.39453 8.0455 1.39453C12.8035 1.39453 15.1789 5.58104 15.1789 5.58104M15.1789 5.58104V1.81619M15.1789 5.58104H12.0117",
    stroke: "white",
    strokeWidth: 1.29402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d3d1a7ac8ae957a237bb43ae7cad921a.svg";
export { ForwardRef as ReactComponent };